import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
const alert = ({
  type,
  title,
  message,
  options
}) => FloatingAlertStore.addAlert(Object.assign({
  type,
  titleText: title,
  message
}, options));
export const alertSuccess = ({
  title = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "viewsManagement.alerts.generic.success.title"
  }),
  message,
  options
}) => alert({
  type: 'success',
  title,
  message,
  options
});
export const alertFailure = ({
  title,
  message = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "viewsManagement.alerts.generic.failure.message"
  }),
  options
}) => alert({
  type: 'danger',
  title,
  message,
  options
});